import styled from 'styled-components';
import breakpoint from '~/utils/style-utils';
import getRouletteBgColor from '~/components/casino-shared/utilities/get-roulette-bg-color';
import { RouletteNumber } from '../../live-casino/types';
import { breakpointDesktop } from './game-info.styles';

const LastWinningNumbersWrapper = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	align-items: center;
	height: 36px;
	padding: 6px 12px;
	border-radius: 12px;
	background-color: rgba(255, 255, 255, 0.2);
	margin-bottom: 24px;
	margin-inline: 12px;
	overflow: hidden;

	${breakpointDesktop} {
		margin-bottom: 12px;
	}
`;

const LastWinningNumberPill = styled.div<{ number: string }>`
	width: 20px;
	height: 20px;
	position: relative;
	background-color: ${props => getRouletteBgColor(props.number)};
	color: ${props => (props.number === '0' ? 'rgb(0, 199, 107)' : 'white')};
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	font: var(--caption-bold);

	&:first-of-type {
		border: 1px solid rgba(255, 255, 255, 1);
	}
`;

const MultiplierWrapper = styled.div`
	background-color: yellow;
	color: black;
	font-size: 8px;
	position: absolute;
	bottom: 15px;
	left: 50%;
	transform: translateX(-50%);
	width: auto;
	line-height: 12px;
	height: 12px;
	padding: 0 1px;
	border-radius: 2px;
	${breakpoint.lg`
		font-size: 10px;
  `}
`;

const LastWinningNumbers = ({ lastWinningNumbers }: { lastWinningNumbers: RouletteNumber[] }) => {
	return (
		<LastWinningNumbersWrapper>
			{lastWinningNumbers.slice(0, 9).map((lastWinningNumber, i) => (
				<LastWinningNumberPill
					// eslint-disable-next-line react/no-array-index-key
					key={`last-winning-number-${lastWinningNumber.value as unknown as string}-${i}`}
					number={lastWinningNumber.value as unknown as string}
				>
					{lastWinningNumber.value}
					{lastWinningNumber.multiplier && (
						<MultiplierWrapper>x{lastWinningNumber.multiplier}</MultiplierWrapper>
					)}
				</LastWinningNumberPill>
			))}
		</LastWinningNumbersWrapper>
	);
};

export default LastWinningNumbers;
